import { ApiClient } from '@/infra/api-client'
import type { RelationManagerResource } from '@/features/relation-manager/api/relation-manager'

export class RelationManagerApi extends ApiClient {
  get(
    jobId: string,
    signal?: AbortSignal,
  ): Promise<{ success: boolean; data: RelationManagerResource }> {
    return this._get(`api/v1/rms/job/${encodeURIComponent(jobId)}`, undefined, {
      signal,
    })
  }
}
